import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const UserInviteContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "UserInviteContainer" */
      './UserInviteContainer.dynamic'
    ),
  loading: LoadingPageLoadable,
});
